import {useIntl} from "react-intl";
import {useParams} from "react-router-dom";
import errorParser from "../../../../../../components/ErrorParser/ErrorParser";
import axios from "axios";
import React, {useState} from "react";
import './EventSheet.scss';
import {toast} from "react-toastify";
import Button from "../../../../../../components/elements/Button/Button";
import ModalComp from "../../../../../../components/ModalComp/ModalComp";
import Selector from "../../../../../../components/elements/Selector/Selector";
import ModalConfirm from "../../../../../../components/ModalConfirm/ModalConfirm";

export default function ButtonShareWithClientEdit({sheetTemplate, getData, clientCanEdit, clientEditableFields, setClientEditableFields}) {
    const intl = useIntl();
    const jwt = localStorage.getItem('jwt')

    let params = useParams();
    const [modalShareClient, setModalShareClient] = useState(false);
    const [modalEditClientAccess, setModalEditClientAccess] = useState(false);
    const [modalRevokeIsOpen, setModalRevokeIsOpen] = useState(false);
    const [loading, setLoading] = useState(false);


    const sendClientAccess = async (fields) => {
        setLoading(true)
        try {
            await axios.post(
                process.env.REACT_APP_API + "/events/send-access/" + params.id,
                {
                    client_editable_fields: JSON.stringify(fields),
                    client_can_edit: true
                }, {
                    headers: {
                        'Authorization': 'Bearer ' + jwt
                    }
                }
            ).then(async (response) => {
                toast.success(intl.formatMessage({id: 'errors.success.data_has_been_saved'}))
                setModalShareClient(false)
                setModalEditClientAccess(false)
                getData()
                setLoading(false)
            })
                .catch(err => {
                    errorParser(err, intl)
                    setLoading(false)
                })
        } catch (e) {
            toast.error("Eroare la generarea link-ului");
        }
    };
    const editClientAccess = async (client_can_edit, fields) => {
        setLoading(true)
        try {
            let formData = new FormData()
            formData.append('client_editable_fields', JSON.stringify([]))
            formData.append('client_can_edit', false)
            await axios.put(
                process.env.REACT_APP_API + "/events/details/" + params.id,
                {
                    data: JSON.stringify({
                        client_editable_fields: JSON.stringify(fields),
                        client_can_edit
                    })
                }, {
                    headers: {
                        'Authorization': 'Bearer ' + jwt
                    }
                }
            ).then(async (response) => {
                toast.success(intl.formatMessage({id: 'errors.success.data_has_been_saved'}))
                setModalEditClientAccess(false)
                setModalRevokeIsOpen(false)
                getData()
                setLoading(false)
            })
                .catch(err => {
                    errorParser(err, intl)
                    setLoading(false)
                })
        } catch (e) {
            toast.error("Eroare la generarea link-ului");
        }
    };

    return (
        <>

            {/* 1. Trimite acces */}
            {clientCanEdit === false && <Button
                className="btn-primary ms-2 mb-2"
                icon="fa-solid fa-share-nodes"
                value={intl.formatMessage({id: 'general.share_with_client'})}
                type="button"
                onClick={() => setModalShareClient(true)}
            />}

            {/* 2. Editează acces */}
            {clientCanEdit === true && <Button
                className="btn-primary ms-2 mb-2"
                icon="fa-solid fa-pen"
                value={intl.formatMessage({id: 'general.edit_client_access'})}
                type="button"
                onClick={() => setModalEditClientAccess(true)}
            />}

            {/* 3. Oprește acces editare */}
            {clientCanEdit === true && <Button
                className="btn-error ms-2 mb-2"
                icon="fa-solid fa-lock"
                value={intl.formatMessage({id: 'general.revoke_client_access'})}
                type="button"
                onClick={() => setModalRevokeIsOpen(true)}
            />}
            <ModalComp
                title={intl.formatMessage({id: 'general.' + (modalEditClientAccess ? 'edit_client_access' : 'share_with_client')})}
                isOpen={modalShareClient || modalEditClientAccess} onRequestClose={() => {
                setModalShareClient(false)
                setModalEditClientAccess(false)
            }}
                className={"subscription-limit product-modal"}
            >
                <div className={"content"}>
                    {Object.keys(sheetTemplate).length > 0 && Object.keys(sheetTemplate).map((sectionKey) => {
                        const section = sheetTemplate[sectionKey];

                        // pregătim câmpurile din secțiune
                        const options = Object.keys(section)
                            .filter((f) => f !== "order")
                            .map((fieldKey) => {
                                return {
                                    label: intl.formatMessage({id: `events.sheet.${sectionKey}.${fieldKey}`}),
                                    value: fieldKey,
                                };
                            });

                        return (
                            <div key={sectionKey} className="mb-3">
                                {/* titlu secțiune */}
                                <h4 className="mb-2">
                                    {intl.formatMessage({id: `events.sheet.${sectionKey}`})}
                                </h4>

                                <Selector
                                    options={options}
                                    value={clientEditableFields.filter((f) => options.some((opt) => opt.value === f))}
                                    onChange={(values) => {
                                        // scoatem câmpurile din această secțiune
                                        const otherFields = clientEditableFields.filter(
                                            (f) => !options.some((opt) => opt.value === f)
                                        );
                                        // adăugăm noile selecții
                                        setClientEditableFields([...otherFields, ...(values.map(item => item.value))]);
                                    }}
                                    isSearchable={true}
                                    placeholder={intl.formatMessage({id: 'general.select_fields'})}
                                    block
                                    isMulti
                                />
                            </div>
                        );
                    })}


                </div>
                <div className={"footer d-flex"}>
                    <Button
                        className="btn-secondary ms-auto w-100"
                        onClick={() => {
                            if(modalEditClientAccess)
                                editClientAccess(true, clientEditableFields)
                            else
                                sendClientAccess(clientEditableFields);
                        }}
                        disabled={loading}
                        loading={loading}
                        value={intl.formatMessage({id: 'general.buttons.' + (modalEditClientAccess ? 'save' : 'send')})}
                    />
                </div>
            </ModalComp>
            <ModalConfirm
                loading={loading}
                onConfirm={() => editClientAccess(false, [])} // funcția care oprește accesul
                title={intl.formatMessage({id: 'general.revoke_client_access'})}
                modalIsOpen={modalRevokeIsOpen}
                message={intl.formatMessage({id: 'general.confirm_revoke_client_access_message'})}
                onRequestClose={() => setModalRevokeIsOpen(false)}
            />
        </>
    );
}
